/*eslint-disable*/
import React, { useState, useEffect } from 'react'
import { withFormik, Form as Formiker, Field as Fieldmik } from 'formik';
import * as yup from 'yup';
import { Form as FormUi, Container, Button, Label, Modal, } from 'semantic-ui-react';
import MyJobcardType from '../apiInputComponent/myjobcardType';
import MyConditions from '../apiInputComponent/myConditions';
import MyRole from '../apiInputComponent/myRole';
import UpdateAxios from '../axiosComponent/update';
import ReadAxios from '../axiosComponent/read';
const EditCondition = ({ values, errors, touched, isSubmitting, handleSubmit, handleClose, ...props }) => {
    const [isChanged, setisChanged] = useState(false)
    const [conditionChanged, setconditionChanged] = useState('')
    // useEffect(() => {
    //     if (values.jobcardType) {
    //         ReadAxios({
    //             url: 'approvalcondition/getJCTypeApprovalCondition', readItems: {
    //                 jobCardTypeId: values.jobcardType
    //             }
    //         })
    //             .then((result) => {
    //                 setconditionChanged(result[0].conditionId)
    //             })
    //     }
    // }, [values.jobcardType])
    let handleCondition = (e, data) => {
        setconditionChanged(data.value)
        setisChanged(!isChanged)
    }
    // values.condition = conditionChanged
    // console.log(values.condition, values.jobcardType)
    return (
        <>
            <Modal.Content>
                {console.log("))))))))))))))))((((((((((((((((((")}
                {console.log(values)}
                {console.log(props)}
                {console.log(props?.startValue)}

                <Container fluid>
                    <div className="ui form tiny">
                        <FormUi.Group width={4}>
                            <FormUi.Field >
                                <label className="labelName p-bold-600">Jobcard Type</label>
                                <Fieldmik autoComplete="off" name="jobcardType" value={values.jobcardType} component={MyJobcardType} />
                                {touched.jobcardType && errors.jobcardType ? <Label size="mini" prompt pointing>{errors.jobcardType}</Label> : ''}
                            </FormUi.Field>
                            <FormUi.Field width={1} />
                            <FormUi.Field >
                                <label className="labelName p-bold-600">Condition</label>
                                <Fieldmik value={values.jobcardType === 1 ? 2 : '' || values.jobcardType === 2 ? 1 : '' || values.jobcardType > 2 ? values.condition : values.condition} disabled={values.jobcardType > 2 ? false : true} autoComplete="off" name="condition" className="disabledField" id="condition" component={MyConditions} />
                                {touched.condition && errors.condition ? <Label size="mini" prompt pointing>{errors.condition}</Label> : ''}
                            </FormUi.Field>
                        </FormUi.Group>
                        <FormUi.Group width={4}>
                            <FormUi.Field>
                                <label className="labelName p-bold-600">Start Value</label>
                                <Fieldmik autoComplete="off" name="startVal" />
                                {touched.startVal && errors.startVal ? <Label size="mini" prompt pointing>{errors.startVal}</Label> : ''}
                            </FormUi.Field>
                            <FormUi.Field width={1} />
                            <FormUi.Field className="ml-2">
                                <label className="labelName p-bold-600">End Value</label>
                                <Fieldmik autoComplete="off" name="endVal" />
                                {touched.endVal && errors.endVal ? <Label size="mini" prompt pointing>{errors.endVal}</Label> : ''}
                            </FormUi.Field>
                        </FormUi.Group>
                        <FormUi.Group>
                            <FormUi.Field>
                                <label className="labelName p-bold-600">Role</label>
                                <Fieldmik autoComplete="off" name="role" value={values.role} component={MyRole} upward />
                                {touched.role && errors.role ? <Label size="mini" prompt pointing>{errors.role}</Label> : ''}
                            </FormUi.Field>
                        </FormUi.Group>
                    </div>
                </Container>
            </Modal.Content>
            <Modal.Actions>
                {isSubmitting ? 'Loading...' : ''}
                <Button onClick={handleClose} type="button" size="tiny">Cancel</Button>
                <Button disabled={isSubmitting} type="submit" onClick={handleSubmit} size="tiny" primary>Submit</Button>
            </Modal.Actions>
        </>
    )
}

const FormikEditCondition = withFormik({
    mapPropsToValues(props) {
        // console.log('-->>', props.conditionId)
        return {
            jobcardType: parseInt(props.jobCardTypeId) || '',
            condition: props.conditionId || '',
            role: props.roleId || '',
            startVal: (props.startValue != null && props.startValue != undefined) && props.startValue >= 0 ? props.startValue : '',
            endVal: props.endValue || '',
            jbConditionId: props.jbConditionId || '',
        }
    },
    validationSchema: yup.object().shape({
        jobcardType: yup.string().required('Required'),
        condition: yup.string().required('Required'),
        role: yup.string().required('Required'),
        startVal: yup.number().min(0).required('Required'),
        endVal: yup.number().when('startVal', (startValue, schema) => (startValue === null ? schema : schema.min(startValue, 'More than Start Value'))).required('Required'),
    }),
    handleSubmit(values, { setErrors, setSubmitting, setSuccess }) {
        // console.log('>>>', values)
        // return
        setSubmitting(true)
        let jobcardType = values.jobcardType
        let jbConditionId = values.jbConditionId
        let condition = values.condition
        let role = values.role
        let startVal = values.startVal
        let endVal = values.endVal
        UpdateAxios({
            url: 'approvalcondition/update',
            updateItems: {
                jbConditionId: jbConditionId,
                conditionId: condition,
                jobCardTypeId: jobcardType,
                startValue: startVal,
                endValue: endVal,
                roleId: role
            },
            updated: (data) => {
                if (data.status === 1) {
                    setTimeout(() => {
                        window.location.reload()
                    }, 1000);
                } else {
                    alert(data.message)
                }
            }
        })

    }
})(EditCondition)

export default FormikEditCondition
